module.exports = __webpack_public_path__ + "static/elwafaapp3-4bfc44c260b8b99297960fcff00b8d59.jpg";